import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { VisitService } from 'src/app/services/visit/visit.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-add-visit-reject-modal',
  templateUrl: './add-visit-reject-modal.component.html',
  styleUrls: ['./add-visit-reject-modal.component.css']
})
export class AddVisitRejectModalComponent implements OnInit {
  visitForm: FormGroup;
  label: string;
  constructor(
    public dialogRef: MatDialogRef<AddVisitRejectModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private visitService: VisitService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    if(this.data.cancelled){
      this.label = "Motivo de cancelación";
    }else{
      this.label = "Motivo de rechazo";
    }

   }

  ngOnInit() {
    this.createForm();
  }

  createForm(){
    this.visitForm = this.formBuilder.group({
      comment: ['', [Validators.required,  Validators.maxLength(500)]],
    })
  }

  save(){
      if(this.visitForm.valid){
        const payload = {
          comment:this.visitForm.value["comment"],
          id: this.data.id,
          idEnterprise: this.data.idEnterprise,
          idUser: localStorage.getItem(AppConstants.Session.USERID)
        }
        this.spinner.show();
        if(this.data.cancelled){
          this.visitService.cancelled(payload).subscribe(_ => {
            if(!_.message){
              this.alertService.showMessage(AppConstants.TitleModal.UPDATE_GATEWAY, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
              this.spinner.hide();
              this.data.result = true;
              this.dialogRef.close(this.data);
            }else{
              this.alertService.showMessage(
                _.message,
                "",
                MessageSeverity.error);
              this.spinner.hide();
            }
          });
        }else{
          this.visitService.rejected(payload).subscribe(_ => {
            if(!_.message){
              this.alertService.showMessage(AppConstants.TitleModal.UPDATE_GATEWAY, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
              this.spinner.hide();
              this.data.result = true;
              this.dialogRef.close(this.data);
            }else{
              this.alertService.showMessage(
                _.message,
                "",
                MessageSeverity.error);
              this.spinner.hide();
            }
          });
        }

      }else{
        this.visitForm.markAllAsTouched();
      }
  }

  close() {
    this.dialog.closeAll();
  }
}
